export const GRUPPO_COLORS = {
  E2SC: "#FF1E27",
  GT: "#3B82F6",
  RS: "#22C55E",
  "A/N": "#FFB703",
  CN: "#A855F7",
  E1: "#06B6D4",
  GTS: "#F97316",
};

export const gruppoColor = (g) => GRUPPO_COLORS[g] || "#9CA3AF";

export function fmtTime(s) {
  if (s === null || s === undefined) return "—";
  const m = Math.floor(s / 60);
  const sec = (s - m * 60).toFixed(2).padStart(5, "0");
  return `${m}:${sec}`;
}

export function fmtGap(leader, current) {
  if (leader === null || leader === undefined || current === null || current === undefined) return "—";
  const gap = current - leader;
  if (gap <= 0) return "—";
  return `+${gap.toFixed(2)}`;
}

export const STATUS_LABELS = {
  in_gara: "IN GARA",
  completed: "TRAGUARDO",
  ritirato: "RITIRATO",
  squalificato: "SQUALIFICATO",
};

export const STATUS_CHIP = {
  in_gara: "bg-[#EAB308]/15 text-[#EAB308] border-[#EAB308]/40",
  completed: "bg-[#22C55E]/15 text-[#22C55E] border-[#22C55E]/40",
  ritirato: "bg-[#EF4444]/15 text-[#EF4444] border-[#EF4444]/40",
  squalificato: "bg-[#EF4444]/15 text-[#EF4444] border-[#EF4444]/40",
};
